import { GDPR_REGIONS, getEnvironmentType, PRODUCTION } from '@cyberint/common-utils';

const CYBERINT_PROD_URL = 'cyberint.cyberint.io';
const CYBERINT_STAGING_URL = 'cyberint.staging.cyberint.io';

const TIP_UI_PATH = '/threat-intel-platform/ui/';

const buildCustomerQuery = customerId => (customerId ? `?customer_id=${encodeURIComponent(customerId)}` : '');

export const getTipExternalUrl = ({ server, region = GDPR_REGIONS.US, customerId } = {}) => {
  const host = server || (getEnvironmentType() === PRODUCTION ? CYBERINT_PROD_URL : CYBERINT_STAGING_URL);
  return `https://${host}/${(region || GDPR_REGIONS.US).toLowerCase()}${TIP_UI_PATH}${buildCustomerQuery(customerId)}`;
};

export const getTipDevProxyPath = ({ region = GDPR_REGIONS.US, customerId } = {}) =>
  `/${(region || GDPR_REGIONS.US).toLowerCase()}${TIP_UI_PATH}${buildCustomerQuery(customerId)}`;
